export interface JwtPayload {
  exp?: number;
  iat?: number;
  sub?: string;
}

export function getTokenExpiration(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const parsed = JSON.parse(decoded) as JwtPayload;
    return typeof parsed.exp === 'number' ? parsed.exp : null;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, bufferSeconds = 30): boolean {
  const exp = getTokenExpiration(token);
  if (exp === null) return true;
  return Math.floor(Date.now() / 1000) >= exp - bufferSeconds;
}
